export interface FormTabName {
    formNavLabel: string;
    formLabel: string;
    id: string;
    controls: Array<Array<string>>;
    groupValidationKeys: Array<string>;
}

export const FormTabNames: { [key: string]: FormTabName } = ({
    CampaignDetails: {
        formNavLabel: 'Campaign Details',
        formLabel: 'Campaign Details',
        id: 'campaignDetailsTab',
        controls: [
            ['name'],
            ['startDate'],
            ['endDate']
        ],
        groupValidationKeys: [
            'invalidSellerCreativeDate',
            'invalidProduceCreativeDate',
            'invalidDateRange',
            'invalidStartDate',
            'invalidSelectedDate'
        ]
    },
    Audience: {
        formNavLabel: 'Target Audience',
        formLabel: 'Target Audience',
        id: 'targetAudienceTab',
        controls: [
            ['segment'],
            ['gender'],
            ['age'],
            ['languages'],
            ['genres'],
            ['channels']
        ],
        groupValidationKeys: [
            'emptyLanguageChannel'
        ]
    },
    Budget: {
        formNavLabel: 'Budget',
        formLabel: 'Budget',
        id: 'budgetTab',
        controls: [
            ['budget'],
            ['goalType'],
            ['autoSelect']
        ],
        groupValidationKeys: [
            'invalidGoal'
        ]
    },
    Ad: {
        formNavLabel: 'Media',
        formLabel: 'Media',
        id: 'mediaTab',
        controls: [
            ['creatives']
        ],
        groupValidationKeys: [
            'creativesRequired',
            'languagesEmptyForCreative',
            'invalidLanguagesForCreative',
            'languagesEmptyForMediacorpCreative',
            'invalidLanguagesForMediacorpCreative'
        ]
    },
})